module.exports = __webpack_public_path__ + "img/small-ship-wreck-d.fe9f20d1.png";